import React, { useContext } from 'react';
import { Button } from './components/Button';
import AppContext from './AppContext';
import { getRandomInt } from './helper';
import PokedexMenuSprite from './PokedexMenuSprite';

const getNextIndex = (currentIndex: number, size: number, isForward: boolean) => {
  let nextIndex = isForward ? currentIndex + 1 : currentIndex - 1;
  if (!isForward && currentIndex === 0) {
    nextIndex = size - 1;
  } else if (isForward && currentIndex === size - 1) {
    nextIndex = 0;
  } else if (currentIndex === -1) {
    nextIndex = currentIndex === -1 ? 0 : nextIndex;
  }
  return nextIndex;
};

function PokedexChangePokemonButtons() {
  const {
    clickedSpeciesId,
    setClickedSpeciesId,
    filteredSpeciesIds,
    spritePosition,
  } = useContext(AppContext);
  const currentSpeciesIndex = filteredSpeciesIds.indexOf(clickedSpeciesId);
  const filteredListSize = filteredSpeciesIds.length;
  const handleRandom = () => {
    setClickedSpeciesId(filteredSpeciesIds[getRandomInt(filteredListSize)]);
  };

  const handleNext = (isForward: boolean) => {
    const nextIndex = getNextIndex(currentSpeciesIndex, filteredListSize, isForward);
    setClickedSpeciesId(filteredSpeciesIds[nextIndex]);
  };

  return (
    <div className="w-full flex gap-1 justify-center">
      <Button
        variant="secondary"
        onClick={() => handleNext(false)}
        disabled={filteredListSize === 0}
      >
        <div className="mb-2">
          <PokedexMenuSprite
            currentSpritePosition={
              spritePosition[
                filteredSpeciesIds[getNextIndex(currentSpeciesIndex, filteredListSize, false)]
              ]
            }
          />
        </div>
      </Button>
      <Button
        variant="secondary"
        onClick={handleRandom}
        disabled={filteredListSize === 0}
      >
        &#128256;
      </Button>
      <Button
        variant="secondary"
        onClick={() => handleNext(true)}
        disabled={filteredListSize === 0}
      >
        <div className="mb-2">
          <PokedexMenuSprite
            currentSpritePosition={
              spritePosition[
                filteredSpeciesIds[getNextIndex(currentSpeciesIndex, filteredListSize, true)]
              ]
            }
          />
        </div>
      </Button>
    </div>
  );
}

export default PokedexChangePokemonButtons;
